<div class="container" [class.wallet-container]="isWalletPage && !isDesktop">
    <img src="assets/images/icons/no-result.svg" alt="No Result" *ngIf="!isDesktop">
    <img src="assets/images/icons/no-result-desktop.svg" alt="No Result" *ngIf="isDesktop">
    <p>There is No Record !</p>
</div>